/* Content for the My Psychic Edge project card */
export const HIGHLIGHTS = [
    "SEO Content Strategy & Article Writing",
    "Parapsychology & Consciousness Research",
    "Independent Publishing & Site Ownership",
    "Audience Building Through Curiosity-Driven Content",
];

export const CONTENT = {
    subtitle: "The edge of consciousness",
};
